import * as UI from '@brewlogix/blx-ui'
import * as React from 'react'

import { ApproximateDistance, NearbyAttraction } from 'src/types/schema/graphql'
import { parseEnumLabel } from 'src/util/helpers'

interface IAttractionCard {
    attraction: NearbyAttraction
}

const AttractionCard: React.FC<IAttractionCard> = ({ attraction }) => {
    const icon = (a: ApproximateDistance): string => {
        switch (a) {
            case ApproximateDistance[String(ApproximateDistance.ShortBikeRide)]:
                return 'Bike'
            case ApproximateDistance[String(ApproximateDistance.ShortCarRide)]:
                return 'Car'
            case ApproximateDistance[String(ApproximateDistance.ShortWalk)]:
                return 'Walk'
            default:
                return 'Walk'
        }
    }
    const { title, approximateDistance: a } = attraction

    const distance = parseEnumLabel(a[0])

    return (
        <div className='min-h-32 min-w-36 rounded-md border-px border-gray-100'>
            <div className='flex h-full flex-col place-content-between items-start p-4'>
                <UI.Icon slug={icon(a[0])} customClasses='' />
                <div className='space-y-1'>
                    <p className='text-md text-gray-500'>{title}</p>
                    <p className='text-sm font-black'>{distance}</p>
                </div>
            </div>
        </div>
    )
}

export default AttractionCard
